import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RequestPanelStore } from '@app/requests/@shared/request-panel/request-panel.store';
import { Operation } from '@app/requests/model/requests-model';
import { TranslateService } from '@ngx-translate/core';
import { ResponseDialogComponent } from '../response/response-dialog.component';

@Component({
  selector: 'app-forward-link',
  templateUrl: './forward-link.component.html',
  styleUrls: ['./forward-link.component.scss'],
})
export class ForwardLinkComponent implements OnInit {
  public phone: boolean;
  public email: boolean;
  private operative: Operation;

  constructor(
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<ForwardLinkComponent>,
    private translateService: TranslateService,
    private requestPanelStore: RequestPanelStore,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.operative = data.operation;
    this.phone = data.phone;
    this.email = data.email;
  }

  ngOnInit() {
    // do nothing
  }

  sendToPhone() {
    let type: string = 'mobile';
    this.callResend(type);
  }

  sendToEmail() {
    let type: string = 'email';
    this.callResend(type);
  }

  callResend(type: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '550px';

    this.requestPanelStore.resendLink(this.operative, type).then(
      (data) => {
        dialogConfig.data = {
          text: 'El reenvío se ha realizado correctamente',
          icon: 'icon-ic_circle_check',
          buttonCancel: false,
          noRedirect: true,
        };
        this.dialog.open(ResponseDialogComponent, dialogConfig);
      },
      (error) => {
        dialogConfig.data = {
          text: 'Error al realizar el reenvío',
          icon: 'icon-ic_circle_cross',
          buttonCancel: false,
          noRedirect: true,
        };
        this.dialog.open(ResponseDialogComponent, dialogConfig);
        console.error(error);
      }
    );
    this.dialogRef.close(true);
  }
}
